import { AbstractControl } from '@angular/forms';

import { UploadFileControl } from '../type';

export const RequiredFileValidator = (control: AbstractControl<UploadFileControl>) => {
  return !control.value || !control.value.size ? { required: true } : null;
};

export const FileNameValidator = (control: AbstractControl<UploadFileControl>) => {
  if (!control.value || !control.value.size) return null;

  const value = Array.from(control.value);
  // const allowRegExp = /[\\{}^\%`\[\]">~<#|\/\x80-\xFF]/;
  const allowRegExp = /^[a-zA-Z0-9!_.*'()&$@=;:+\s,?\-"]+$/;
  let fileName = false;
  value.every(([, v]) => {
    if (v.file) {
      const name = getFileNameWithoutExtension(v.file.name);
      if (!allowRegExp.test(name) || v.file.name.length > 150) {
        v.error = { code: 'invalid_name' };
        fileName = true;
      }
    }

    return true; // Make sure you return true. If you don't return a value, `every()` will stop.
  });

  return fileName ? { fileName } : null;
};

export const MaxSelectFileValidator = (maxLength: number) => {
  return (control: AbstractControl<UploadFileControl>) => {
    if (!control.value || control.value.size <= maxLength) return null;
    return { maxSelectFile: { requiredSelect: maxLength, actualSelect: control.value.size } };
  };
};

export const MaxSizeFileValidator = (maxSize: number) => {
  return (control: AbstractControl<UploadFileControl>) => {
    if (!control.value || !control.value.size) return null;

    const value = Array.from(control.value);
    let maxSizeFile = false;

    value.every(([, v]) => {
      if (v?.file && v?.file.size > maxSize) {
        v.error = { code: 'large_size' };
        maxSizeFile = true;
      }

      return true; // Make sure you return true. If you don't return a value, `every()` will stop.
    });

    return maxSizeFile ? { maxSizeFile } : null;
  };
};

export const MinSizeFileValidator = (minSize: number) => {
  return (control: AbstractControl<UploadFileControl>) => {
    if (!control.value || !control.value.size) return null;

    const value = Array.from(control.value);
    let minSizeFile = false;

    value.every(([, v]) => {
      if (v?.file && v?.file.size < minSize) {
        v.error = { code: 'too_small_size' };
        minSizeFile = true;
      }

      return true; // Make sure you return true. If you don't return a value, `every()` will stop.
    });

    return minSizeFile ? { minSizeFile } : null;
  };
};

function getFileNameWithoutExtension(filename: string): string {
  const lastDotIndex = filename.lastIndexOf('.');
  if (lastDotIndex === -1) {
    // If there is no dot in the filename, return the filename itself
    return filename;
  } else {
    // Otherwise, return the filename up to the last dot
    return filename.substring(0, lastDotIndex);
  }
}
